import React from 'react';
import PropTypes from 'prop-types';
import CheckboxTreeSelector from '../../CheckboxTreeSelector';
import noop from '../../../../tools/noop';

const OperatorSelectionSelector = (props) => {
  const {
    title = 'OPERATOR & IMPC',
    expanded = [],
    checked = [],
    postalOperatorNodes = [],
    expandDisabled = false,
    onCheck = noop,
    onExpand = noop,
    onSelectAll = noop,
    onDeSelectAll = noop,
    appContextType,
    onContextClick = noop,
  } = props;

  return (
    <div className="operator-selector-container">
      <CheckboxTreeSelector
        title={title}
        nodes={postalOperatorNodes}
        checked={checked}
        expanded={expanded}
        onCheck={onCheck}
        onExpand={onExpand}
        expandDisabled={expandDisabled}
        onSelectAll={onSelectAll}
        onDeSelectAll={onDeSelectAll}
        appContextType={appContextType}
        onContextClick={onContextClick}
      />
    </div>
  );
};

OperatorSelectionSelector.propTypes = {
  title: PropTypes.string,
  postalOperatorNodes: PropTypes.arrayOf(PropTypes.object),
  onCheck: PropTypes.func,
  onExpand: PropTypes.func,
  checked: PropTypes.arrayOf(PropTypes.string),
  expanded: PropTypes.arrayOf(PropTypes.string),
  onSelectAll: PropTypes.func,
  onDeSelectAll: PropTypes.func,
  expandDisabled: PropTypes.bool,
  appContextType: PropTypes.string,
  onContextClick: PropTypes.func,
};

export default OperatorSelectionSelector;
